import Aboutus from "./Aboutus/Aboutus";
import AppScreens from "./AppScreens/AppScreens";
import DownloadApp from "./DownoadApp/DownoadApp";
import Features from "./Features/Features";
import Footer from "./Footer/Footer";
import Hero from "./Hero/Hero";
import "./Layout.css";
import Navber from "./Navber/Navber";
import Packages from "./Packages/Packages";
import Testimonials from "./Testimonials/Testimonials";

export default function Layout() {
  return (
    <div className="layout">
      <header>
        <Navber />
      </header>
      <main>
        <Hero /> 
        <Aboutus />
        <Features /> 
        <AppScreens />
        <Testimonials />
        <Packages />
        <DownloadApp />
      </main>
      <Footer /> 
    </div>
  );
}
